export default {
    CashRespond: {
        respond_reject_message: 'Cash loading process has been canceled',
        respond_success_message: 'Cash loading process was successful',
        cancel_alert_title: 'Cancel Loading',
        cancel_alert_message:
            'Are you sure you want to cancel the cash loading process?',
        alert_cancel_button: 'Cancel',
        alert_approve_button: 'Yes',
        action_button_cancel_title: 'Cancel',
        action_button_respond_title: 'Approve',
        respond_price_header_title: 'Amount to be Loaded',
        respond_price_header_description:
            'Please pay attention to the cash loading information',
    },
    MasterPassCardRegister: {
        route_header_title: 'Add Card',
        content_header_title: 'Add Card with Masterpass',
        content_header_description:
            'Your card information is securely stored with Masterpass',
        form_label_card_number: 'Card Number',
        form_label_expiry_date: 'Expiry Date',
        form_label_account_alias_name: 'Give a Name to the Card',
        form_placeholder_expiry_date: 'MM/YY',
        form_placeholder_account_alias_name: 'e.g., My Card',
        form_agreement_checkbox_title:
            'I have read the <0 href="https://www.masterpassturkiye.com/TermsAndConditions.aspx">Masterpass User Agreement</0> and want to store my card in the Masterpass infrastructure',
        mp_user_agreement_url:
            'https://www.masterpassturkiye.com/TermsAndConditions.aspx',
        mp_user_agreement_header_title: 'Masterpass User Agreement',
        form_submit_button: 'Add Card',
    },
    MasterPassCards: {
        route_header_title: 'My Masterpass Cards',
        content_header_description:
            'You can select and edit your preferred payment methods',
        mp_delete_alert_title: 'Delete Card',
        mp_delete_alert_message:
            'Are you sure you want to delete your card\nregistered with Masterpass?',
        mp_delete_alert_approve_button: 'Yes',
        mp_delete_alert_cancel_button: 'Cancel',
        register_card_row_item_title: 'Add New Card',
        delete_alert_button: 'Delete',
        card_change_alert_title: 'Your top-up instruction will be cancelled',
        card_change_alert_message:
            'Your top-up instruction for {{company}} is tied to this card. If you change your card, the instruction is cancelled and you need to create it again with the new card.',
        card_change_alert_message_multiple:
            '{{count}} of your top-up instructions are tied to this card. If you change your card, they are cancelled and you need to create them again with the new card.',
        card_change_alert_approve_button: 'Continue',
        card_change_alert_cancel_button: 'Dismiss',
        instruction_cancelled_toast_message:
            'Your top-up instruction was cancelled because you changed your card. Your details are kept — create it again with the new card.',
        mp_delete_alert_instruction_message:
            'You have a top-up instruction tied to this card.\nDeleting the card also cancels the instruction. Do you want to continue?',
    },
    MasterPassHelp: {
        route_header_title: 'Masterpass Support',
        question_card_title: 'Are you the cardholder?',
        question_card_description:
            'If the registered mobile number of the cardholder does not belong to you, the SMS will not be sent to you, but will be sent to the cardholder.',

        question_time_title: 'Has the card expired?',
        question_time_description:
            'If the validity of the added card has expired, you may not receive an SMS during the login process.',
        question_number_title: 'Have you changed your registered number?',
        question_number_description:
            'If a card belonging to you has already been registered with a different number, you may not receive an SMS.',
        question_do_what_title: 'What should I do?',
        question_do_what_description:
            'For all these cases, you can update your card information by logging in with your account on the official page of Masterpass, and then try the pairing again in Macellan SuperApp.',
        action_button_help: 'Go to Masterpass Support',
    },
    MasterPassLink: {
        route_header_title: 'Card Linking',
        info_sheet_title: 'Masterpass Card Linking',
        info_sheet_description:
            'You can link your Masterpass account for faster loading',
        info_sheet_question: 'Do you want to continue?',
        info_sheet_approve_button: 'Link Card',
        info_sheet_cancel_button: 'Cancel',
    },
    MasterPass3D: {
        error_message: '3D verification process failed',
        timeout_alert_title: 'This is taking longer than expected',
        timeout_alert_message:
            'The bank has not returned a result yet. You can keep waiting or go back to your wallet and check the result in your wallet transactions.',
        timeout_alert_approve_button: 'Back to Wallet',
        timeout_alert_cancel_button: 'Keep Waiting',
    },
    MasterPassOTP: {
        route_header_title: 'Masterpass Verification',
        content_header_title: 'Masterpass Verification',
        content_header_description: 'Enter the 6-digit code sent to your phone',
        resend_otp_toast_message: 'Verification code has been resent',
        success_type_link:
            'Your Masterpass account has been successfully linked',
        success_type_register:
            'Card registration was successful with Masterpass',
        resend_otp_button: 'Resend',
        help_button_text: 'Facing an issue?',
        error_message: 'Payment process failed',
    },
    MasterPassInstructionOTP: {
        route_header_title: 'Masterpass Verification',
        content_header_description: 'Enter the 6-digit code sent to your phone',
        resend_otp_toast_message: 'Your verification code has been resent',
        resend_otp_button: 'Resend',
        help_button_text: 'Need Help ?',
        error_message: 'Your instruction transaction failed',
        success_toast_message: 'Top-up instruction created successfully',
        success_update_toast_message: 'Top-up instruction updated successfully',
    },
    TopUpInstruction: {
        route_header_title: 'Top-up Instruction',
        tab_title_instruction: 'My Instruction',
        tab_title_inactive: 'My Past Instructions',
        inactive_content_header_description:
            'You can view your cancelled, suspended or expired instructions here.',
        info_title: 'How does a top-up instruction work?',
        info_description:
            'When your balance and points together drop below the amount you set, your wallet is automatically topped up to this amount from your saved Masterpass card.',
        instruction_target_balance_section_title: 'TARGET WALLET BALANCE',
        instruction_target_balance_section_description:
            'When your balance drops below this amount, your wallet is topped up to this amount.',
        instruction_date_section_title: 'EXPIRY DATE',
        deposit_method_section_title: 'PAYMENT METHOD',
        form_date_picker_placeholder: 'Select a date',
        footer_submit_button: 'Create Instruction',
        footer_update_button: 'Update Instruction',
        footer_cancel_button: 'Cancel Instruction',
        date_min_today: 'The expiry date cannot be before today',
        date_min_tomorrow: 'The expiry date can be tomorrow at the earliest',
        status_pending: 'Pending',
        status_active: 'Active',
        status_suspended: 'Suspended',
        status_cancelled: 'Cancelled',
        status_expired: 'Expired',
        empty_sheet_title: 'You have no instructions yet.',
        empty_sheet_description:
            'Your cancelled, suspended or expired instructions are listed in this section.',
        detail_sheet_title: 'Instruction Details',
        detail_sheet_description:
            'This instruction is no longer active. You can review its details below.',
        detail_section_title: 'INSTRUCTION DETAILS',
        detail_target_balance_title: 'Target Wallet Balance',
        detail_end_date_title: 'Expiry Date',
        detail_card_title: 'Card',
        detail_total_loaded_title: 'Total Loaded',
        detail_last_load_title: 'Last Top-up',
        instruction_cancellation_title: 'CANCELLATION DETAILS',
        instruction_cancellation_reason_title: 'Cancellation Reason',
        instruction_cancellation_date_title:
            'This top-up instruction was cancelled on {{canceledDate}}.',
        instruction_expired_title:
            'This top-up instruction expired on {{expiredDate}}.',
        alert_title: 'Edit Instruction',
        alert_description: 'You can reactivate or cancel your instruction.',
        alert_activate_title: 'Activate Instruction',
        alert_activate_description:
            'Are you sure you want to activate this instruction?',
        alert_deactivate_title: 'Cancel Instruction',
        alert_deactivate_description:
            'Are you sure you want to cancel this instruction?',
        alert_activate_button: 'Activate Instruction',
        alert_deactivate_button: 'Cancel Instruction',
        alert_reject_button: 'Dismiss',
        success_activate_toast_message:
            'Top-up instruction activated successfully',
        success_cancel_toast_message:
            'Top-up instruction cancelled successfully',
    },
    TopUp: {
        route_header_title: 'Load Balance',
        amount_section_title: 'AMOUNT TO BE LOADED',
        deposit_chips_other_label: 'Other Amount',
        payment_method_section_title: 'PAYMENT METHOD',
        toast_success_message: 'Loading process was successful',
        footer_balance_title: 'Amount to be Loaded',
        footer_submit_button: 'Load Balance',
        other_payment_method_section_title: 'OTHER PAYMENT METHODS',
        other_deposit_method_deposit_card_title:
            'Load Balance By Entering Card Number',
        other_deposit_method_cash_deposit_card_title: 'Cash Loading',
        empty_deposit_method_title: 'Transaction Information',
        empty_deposit_method_description:
            'You will be able to add balance to this brand very soon',
        empty_deposit_method_question:
            'If you wish, you can make a purchase by adding a coupon',
        balance: 'Balance',
        info_title: 'What are my benefits when adding balance?',
        info_description:
            'When you add balance, you earn points according to the campaigns in the wallet.',
        installment_section_title: 'INSTALLMENT OPTİONS',
        installment_section_more_button_title:
            'All Installment Options ({{count}})',
        installment_section_hide_button_title: 'Hide',
        installment_section_single_payment_title: 'Single Payment',
        installment_section_other_title:
            '{{installmentCount}} Installment x {{formattedInstallmentAmount}}',
        empty_deposit_method_coupon_button: 'Add Coupon',
        custom_amount_validation:
            'Please enter a value between {{min}} and {{max}}',
    },
    EarnablePoint: {
        point_title: 'Gift points you will earn',
        point_label: 'Points',
        up_has_toast_message:
            'Load <0>{{formattedIncreaseAmount}}</0> more,\nearn <0>{{formattedHasPoint}} points</0> instantly!',
        up_has_toast_chip: 'Add Now',
    },
    MasterPassDepositCard: {
        register_description: 'Add Card with Masterpass',
        link_description: 'Link Card with Masterpass',
        edit_button: 'Edit',
    },
    TopUpDepositCard: {
        change_button: 'Change',
    },
    TopUpAnotherCard: {
        content_header_title: 'Load Balance By Entering Card Number',
        content_header_description:
            'Your card information is securely stored with MasterPass',
        form_label_credit_card_no: 'Card Number',
        form_label_expire_date: 'Expiry Date',
        form_label_cvc_no: 'Security Code',
        form_placeholder_expire_date: 'MM/YY',
        form_placeholder_cvc_no: 'CVC/CVV',
        form_label_name: 'Give a Name to the Card',
        form_placeholder_name: 'e.g., My Card',
        form_save_card_title: 'Save this card for future loadings',
        form_submit_button: 'Load Balance',
        form_agreement_checkbox_title:
            'I have read the <0 href="https://www.masterpassturkiye.com/TermsAndConditions.aspx">Masterpass User Agreement</0> and want to store my card in the Masterpass infrastructure',
        mp_user_agreement_header_title: 'Masterpass User Agreement',
        mp_user_agreement_url:
            'https://www.masterpassturkiye.com/TermsAndConditions.aspx',
        max_number_of_cards_error: 'You can add up to 7 cards.',
    },
    DepositRefund: {
        route_header_title: 'Deposit Refund',
        toast_error_message: 'Deposit refund failed',
    },
    DepositRefundSummary: {
        content_header_title: 'Deposit Refund Summary',
        content_header_description:
            'Please review the summary information before confirming your refund.',
        detail_section_title: 'REFUND DETAILS',
        detail_balance_to_be_deducted: 'Balance to Be Deducted from Wallet',
        detail_points_to_be_deducted: 'Points to Be Recovered',
        detail_earned_points_from_deposit: 'Points Earned from Deposit',
        detail_point_deducted_from_balance:
            'Points to Be Deducted from Balance at Refund',
        detail_net_amount_to_be_refunded_to_card:
            'Net Amount to Be Refunded to Card',
        submit_button_text: 'Confirm',
        toast_success_message: 'Deposit refund successful',
    },
    GoldFramer: {
        warning_message: '{{amount}} will be charged to your card.',
    },
}
